import React, { useState, useEffect } from 'react';
import {
  TFolderPicture,
  TPicture
} from '../../../types/cloudStorage/CloudFileList';
import { useSnackbar } from 'notistack';
import { useRecoilValue } from 'recoil';
import { folderListState, selectedPicturesState } from '../../../GlobalState';
import { Image } from './Image';
import { TLedgerPictur } from '../../../types/Ledger';

type TProps = {
  openFolderId: any;
  imageData: TLedgerPictur[] | undefined;
};

export const PictureList: React.FC<TProps> = (props: TProps) => {
  const { openFolderId, imageData } = props;

  // フォルダーリスト(ファイルデータ含む)
  const folderList = useRecoilValue<TFolderPicture[]>(folderListState);

  const [pictureList, setPictureList] = useState<TPicture[]>([]);

  useEffect(() => {
    const folder: TFolderPicture | undefined = folderList.find(
      (item: TFolderPicture) => item.id == openFolderId
    );
    if (folder) {
      setPictureList(folder.pictures);
    }
  }, []);

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', margin: '10px 0' }}>
      {pictureList &&
        pictureList.length > 0 &&
        pictureList.map((picture: TPicture, index: number) => (
          <div
            key={`PictureList_${index}`}
            style={{
              width: 100,
              display: 'grid',
              placeItems: 'center'
            }}
          >
            <div
              style={{
                borderTop: 'solid 1px #808080',
                width: 80,
                height: 80
              }}
            >
              <Image
                picture={picture}
                shooting_date={picture.shooting_date}
                imageData={imageData}
              />
            </div>
            <div style={{ fontSize: 12, color: 'gray' }}>
              {picture.shooting_date.replace(/-/g, '.')}
            </div>
          </div>
        ))}
    </div>
  );
};
